module.exports = __webpack_public_path__ + "static/media/05_application_after_calc.e4bcf9fa.png";